import React from 'react';
import { Modal } from 'antd';
import moment from 'moment';
import Loader from './Loader';
import './TrackingModal.css';

const TrackingModal = ({ open, onCancel, loading, data, orderInfo }) => {
    const getStatusClass = (category) => {
        if (!category) return 'status-unknown';
        const cat = category.toLowerCase();
        if (cat === 'delivered') return 'status-delivered';
        if (cat.includes('transit') || cat.includes('progress')) return 'status-transit';
        if (cat.includes('attempt') || cat.includes('issue')) return 'status-warning';
        return 'status-transit';
    };

    const renderContent = () => {
        if (loading) return <div className="text-center p-4"><Loader /></div>;
        if (data?.error) {
            const message = typeof data.error === 'string'
                ? data.error
                : data.error.moreInformation || data.error.httpMessage || 'No tracking data available.';
            return <div className="text-center p-4">{message}</div>;
        }
        if (data && data.payload) {
            const payload = data.payload;
            const events = payload.eventHistory ? [...payload.eventHistory].reverse() : [];
            const summary = payload.summary;
            const trackingId = summary?.trackingId || payload.trackingId ||  orderInfo?.trackingNumber;
            const status = summary?.status || 'Unknown';

            return (
                //Amazon data
                <div className="modal-tracking-content">
                    <div className="modal-summary-card">
                        <div className="summary-left">
                            <div className="tracking-id">{trackingId}</div>
                            <div className="product-name">Amazon Shipping</div>
                            <div className="product-desc">Standard Delivery</div>
                        </div>
                         <div className="summary-right">
                            <span className={`status-pill large ${getStatusClass(status)}`}>
                                {status}
                            </span>
                        </div>
                    </div>

                    {summary?.proofOfDelivery?.deliveryImageURL && (
                         <div className="summary-line-box">
                            <i className="fas fa-camera"></i> <a href={summary.proofOfDelivery.deliveryImageURL} target="_blank" rel="noopener noreferrer">View Proof of Delivery</a>
                        </div>
                    )}

                    <div className="modal-timeline">
                        <h5>Tracking History</h5>
                        {events.length > 0 ? (
                            <div className="timeline-list">
                                {events.map((event, idx) => (
                                    <div className={`timeline-item ${idx === 0 ? 'latest' : ''}`} key={idx}>
                                        <div className="timeline-marker"></div>
                                        <div className="timeline-content">
                                            <div className="event-name">{event.eventCode}</div>
                                            <div className="event-meta">
                                                 {event.location?.city && <span><i className="fas fa-map-marker-alt"></i> {event.location.city}, {event.location.postalCode}</span>}
                                                <span><i className="fas fa-clock"></i> {moment(event.eventTime).format('DD MMM YYYY, HH:mm')}</span>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="text-muted">No tracking events available.</div>
                        )}
                    </div>
                </div>
            )
        }

        // Royal Mail. The events call sometimes returns one piece, sometimes a list.
        const mailPieces = Array.isArray(data?.mailPieces) ? data.mailPieces[0] : data?.mailPieces;
        if (!mailPieces) return <div className="text-center p-4">No tracking data available.</div>;

        const mp = mailPieces;
        const events = mp.events || [];
        const summary = mp.summary;

        return (
            <div className="modal-tracking-content">
                <div className="modal-summary-card">
                    <div className="summary-left">
                        <div className="tracking-id">{mp.mailPieceId}</div>
                        <div className="product-name">{summary?.productName || 'Royal Mail'}</div>
                        <div className="product-desc">{summary?.productDescription || ''}</div>
                    </div>
                    <div className="summary-right">
                        <span className={`status-pill large ${getStatusClass(summary?.statusCategory)}`}>
                            {summary?.statusDescription || 'Unknown'}
                        </span>
                    </div>
                </div>

                {summary?.summaryLine && (
                    <div className="summary-line-box">
                        <i className="fas fa-info-circle"></i> {summary.summaryLine}
                    </div>
                )}

                <div className="modal-timeline">
                    <h5>Tracking History</h5>
                    {events.length > 0 ? (
                        <div className="timeline-list">
                            {events.map((event, idx) => (
                                <div className={`timeline-item ${idx === 0 ? 'latest' : ''}`} key={idx}>
                                    <div className="timeline-marker"></div>
                                    <div className="timeline-content">
                                        <div className="event-name">{event.eventName}</div>
                                        <div className="event-meta">
                                            {event.locationName && <span><i className="fas fa-map-marker-alt"></i> {event.locationName}</span>}
                                            <span><i className="fas fa-clock"></i> {moment(event.eventDateTime).format('DD MMM YYYY, HH:mm')}</span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="text-muted">No tracking events available.</div>
                    )}
                </div>
            </div>
        );
    };

    return (
        <Modal
            title={
                <div className="modal-title-custom">
                    <i className="fas fa-truck"></i> Tracking Details
                    {orderInfo && (
                        <span className="modal-order-id">Order: {orderInfo.orderId}</span>
                    )}
                </div>
            }
            open={open}
            onCancel={onCancel}
            footer={null}
            width={700}
            className="tracking-modal"
        >
            {renderContent()}
        </Modal>
    );
};

export default TrackingModal;
